/*=========================================================================================
  File Name: state.js
  Description: OrderING Mutations
  ----------------------------------------------------------------------------------------
  Item Name: OrderING State Module
  Author: Tan Tran
==========================================================================================*/

import moment from 'moment';
export default {

    SET_PICKUPNUMBER_STATE (state, payload) {
        state.pickupNumber = payload
    },

    CHANGE_CUSTOMER_NAME_STATE ( state, payload ) {
      state.customerName = payload;
    },

    CHANGE_PHONE_NUMBER_STATE (state, payload) {
      state.phoneNumber = payload;
    },

    CHANGE_PICKUP_TIME_STATE ( state, payload ) {
      //console.log(payload)
      state.pickupTime = payload;
    },

    CHANGE_PRIORITY_STATE (state, payload ) {
      state.priority = payload;
    },

    CHANGE_ASAP_STATE (state, payload) {
      state.ASAP = payload;
    },

    CHANGE_COMMENT_STATE (state, payload) {
      state.comment = payload;
    },

    ADD_ITEM_TO_CART_STATE ( state, payload ) {

      console.log(payload)

      let index = state.cart.findIndex(o => 
        (o.itemId === payload.itemId) && (!payload.isCustomized)
      );

      if (index > -1 && !state.cart[index].isCustomized) {
        state.cart[index].quantity++;
      }
      else {
        index = state.cart.length;
        let newItem = {
          index : index,
          itemId : payload.itemId,
          itemName : payload.itemName,
          price : payload.originalPrice,
          addedPrice : 0.0,
          tax: payload.taxValue,
          discount : payload.discount,
          quantity : 1,
          categoryName : payload.category,
          isCustomized : false,
          groupOptionsJSON : payload.groupOptionsJSON,
          estimatedTime : payload.estimatedTime,
          options : [],
          comment : ''
        }
        state.cart.push(newItem);
      }
      
      //
      //update estimated time
      //
      let totalSeconds = 0;
      state.cart.forEach(item => {
        totalSeconds += (item.estimatedTime * item.quantity)
      });
      console.log('total seconds : ' + totalSeconds)
      let totalMinutes = Math.ceil((totalSeconds / 60));
      console.log('total minutes :' + totalMinutes)
      state.estimatedTime = totalMinutes;

  },

  REMOVE_ITEM_FROM_CART_STATE ( state, payload ) {
      
    state.amount -= state.cart[payload].quantity * (state.cart[payload].price + state.cart[payload].addedPrice);
    state.estimatedTime -= (state.cart[payload].estimatedTime * state.cart[payload].quantity);
    state.cart.splice(payload,1);
    //
    //Rearrange index
    // 
    for (let i = 0; i < state.cart.length; i++) {
      state.cart[i].index = i;
    }
    //
    //update estimated time
    //
    let totalSeconds = 0;
    state.cart.forEach(item => {
      totalSeconds += (item.estimatedTime * item.quantity)
    });
    console.log('total seconds : ' + totalSeconds)
    let totalMinutes = Math.ceil((totalSeconds / 60));
    console.log('total minutes :' + totalMinutes)
    state.estimatedTime = totalMinutes;
  },

  EDIT_ITEM_IN_CART_STATE ( state, payload ) {

      let addedPrice = 0.0;

      payload.options.forEach(o => {
          addedPrice += o.addedPrice;
      });

      state.cart[payload.index].options = payload.options;
      state.cart[payload.index].comment = payload.comment;
      state.cart[payload.index].addedPrice = addedPrice;
      state.cart[payload.index].isCustomized = true;
      //
      //update amount
      //
      state.amount += addedPrice;

      //
      //Update Short Description
      //
      state.cart[payload.index].shortDescription = '';
      let shortNames = [];
      let shortDescription = '';
      
      state.cart[payload.index].options.forEach(o => {
        for(let i = 0; i< o.options.length; i++) {
          shortNames.push(o.options[i].shortName);
        }
      });

      for(let i = 0; i < shortNames.length; i++) {
        if (shortNames.length - (i +1) > 0) {
          shortDescription += shortNames[i] + ' , ';
        }
        else {
          shortDescription += shortNames[i];
        }
      }

      state.cart[payload.index].shortDescription = shortDescription;

  },

  UPDATE_ITEM_QUANTITY_IN_CART_STATE (state, payload ) {
      state.amount = 0.0;
      state.cart.forEach(o => {
        state.amount += (o.price + o.addedPrice) * o.quantity;
      });
  },

  UPDATE_ESTIMATED_PICKUP_TIME_STATE (state, payload) {
    
    let realEstimatedTime = state.estimatedTime;
    let estimatedPickupTime = moment();
    
    if (realEstimatedTime <= payload.minWaitingTime) {
      realEstimatedTime = payload.minWaitingTime;
    }
    if(realEstimatedTime >= payload.maxWaitingTime) {
      realEstimatedTime = payload.maxWaitingTime;
    }

    //
    //update pickup time according to new estimated time
    //
    estimatedPickupTime.add(realEstimatedTime, 'minutes');
    state.pickupTime = estimatedPickupTime;

  },

  UPDATE_ESTIMATED_TIME_STATE (state, payload) {
   //
  //update estimated time
  //
    let totalSeconds = 0;
    state.cart.forEach(item => {
      totalSeconds += (item.estimatedTime * item.quantity)
    });
    console.log('total seconds : ' + totalSeconds)
    let totalMinutes = Math.ceil((totalSeconds / 60));
    console.log('total minutes :' + totalMinutes)
    state.estimatedTime = totalMinutes;
  },


  RESET_STATE(state, payload) {
    console.log('RESET_STATE')
    state.pickupNumber = 0;
    state.customerName = '';
    state.phoneNumber = '';
    state.priority = false;
    state.ASAP = false;
    state.pickupTime = null;
    state.comment = '';
    state.cart.splice(0, state.cart.length);
    state.estimatedTime = 0;
    state.tax = 0.0;

  },

}